module.exports = __webpack_public_path__ + "img/eiffel_tower.de1ba069.png";